/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button, Table, DropdownButton, MenuItem, Clearfix } from 'react-bootstrap';
import { injectIntl, FormattedNumber } from 'react-intl';
import { forEach as _forEach, find as _find } from 'lodash';

import { getVariantDescription } from 'helpers/items';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';
import { clientOptionFromEntity } from 'components/forms/autocomplete/Client';
import { getNetFromGross, getGrossFromNet } from 'helpers/financial';

import EntityStateUpdater from 'component/EntityStateUpdater';

import FormInput from 'components/forms/FormInput';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormHoldingCompany from 'components/forms/FormHoldingCompany';
import DatePicker from 'components/forms/DatePicker';
import FormRichEditor from 'components/forms/FormRichEditor';
import FormItemSearch from 'components/forms/FormItemSearch';
import FormItemManual from 'components/forms/FormItemManual';
import FormPriceNetGross from 'components/forms/FormPriceNetGross';
import FormErrors from 'components/forms/FormErrors';
import List from 'components/List';

import Loader from 'components/layout/Loader';
import IntlDate from 'components/layout/IntlDate';
import SalesDocumentSummary from 'components/layout/SalesDocumentSummary';

import ItemVariantSelectors from 'components/layout/itemDetails/ItemVariantSelectors';

import Entity from 'components/Entity';
import Data from 'components/Data';
import Modal from 'components/Modal';

import { entityMetaMapping } from 'js/constants';
import ReactHtmlParser from 'react-html-parser';
import QuoteAddress from '../layout/quote/QuoteAddress';
import FormSwitchery from '../forms/FormSwitchery';
import { getDescriptionInCurrentLanguage, getNameInCurrentLanguage } from "helpers/intl";

const { quote: FINANCE_QUOTE } = entityMetaMapping;

class LeadQuoteNewCopy extends EntityStateUpdater {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      entity: null,
      entityLoaded: false,
      editedRow: null,
      owner: null,
      showEditDeliveryDate: false,
      showEditComment: false,
      showAddItem: false,
      showAddManual: false,
      itemVariantValidation: {},
      showEditDeliveryAddress: true,
      sendByEmail: false,
      dataToEdit: undefined,
      editingRow: undefined,
      showEditTermsOfPayment: false,
    };

    this.entity = new Entity();
    if (props.meta[FINANCE_QUOTE] !== undefined && !props.meta[FINANCE_QUOTE].pending) {
      this.entity.setMeta(props.meta, FINANCE_QUOTE);

      this.state = {
        ...this.state,
        entityLoaded: true,
        entity: this.entity,
      };
    }

    const {
      intl: { messages },
    } = props;

    /* see FinanceBundle\Document\Quote::STATUS_ACTIVE and STATUS_CANCELLED */
    this.choices = {
      active: messages.active_quote,
      cancelled: messages.canceled_quote,
    };
  }

  componentDidUpdate = prevProps => {
    const { meta, close } = this.props;

    if (meta[FINANCE_QUOTE] !== undefined && !meta[FINANCE_QUOTE].pending && !this.entity.getMetaLoaded()) {
      this.entity.setMeta(meta, FINANCE_QUOTE);
      if (this.entity.getDataLoaded()) {
        setTimeout(() => this.setState({ entityLoaded: true, entity: this.entity }));
      }
    }

    if (prevProps.formStatus.pending !== this.props.formStatus.pending && this.props.formStatus.pending === false) {
      close();
    }
  };

  getDeposit = () => {
    const { webApp } = this.props;
    const { entityLoaded, entity } = this.state;

    if (entityLoaded) {
      let valueLabel;
      let typeLabel;
      const value = entity.deposit || (entity.getDeposit && entity.getDeposit()) || 0;
      const type = entity.deposit_type || (entity.getDepositType && entity.getDepositType()) || 'percent';

      switch (type) {
        case 'fixed': {
          typeLabel = webApp.currencySymbol;
          valueLabel = (
            <FormattedNumber
              value={value}
              style="currency"
              currency={entity.currency || (entity.getCurrency && entity.getCurrency())}
            />
          );
          break;
        }

        case 'percent':
        default: {
          typeLabel = '%';
          valueLabel = <FormattedNumber value={value / 100} style="percent" />;
          break;
        }
      }

      return { valueLabel, value, typeLabel, type };
    }
  };

  depositValueOptions = () => {
    const { type } = this.getDeposit();
    const { entity } = this.state;

    switch (type) {
      case 'fixed': {
        const options = [0, 100, 200, 250, 500, 1000, 2000, 3000, 4000, 5000];
        const res = [];

        _forEach(options, option => {
          res.push(
            <MenuItem key={option} eventKey={option}>
              <FormattedNumber
                value={option}
                style="currency"
                currency={entity.currency || (entity.getCurrency && entity.getCurrency())}
              />
            </MenuItem>
          );
        });

        return res;
      }

      case 'percent':
      default: {
        const res = [
          <MenuItem key="no-deposit" eventKey={0}>
            <FormattedNumber value={0} style="percent" />
          </MenuItem>,
        ];

        for (let i = 0; i < 4; i++) {
          res.push(
            <MenuItem key={i} eventKey={5 + i * 5}>
              <FormattedNumber value={(5 + i * 5) / 100} style="percent" />
            </MenuItem>
          );
        }

        return res;
      }
    }
  };

  onSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    clearTimeout(this.submitTimeout);
    this.submitTimeout = setTimeout(() => {
      this.setState(
        prevState => ({ entity: prevState.entity.validate() }),
        () => {
          const { quote } = this.props;
          const { owner, sendByEmail } = this.state;
          const clientId = quote.target && quote.target.id ? quote.target.id : quote.target.username;
          if (this.state.entity.isValid) {
            this.props.onSubmit(clientId, { ...this.state.entity.processedData, owner, sendByEmail });
          }
        }
      );
    }, 150);

    return false;
  };

  getItems = () => {
    const {
      quote,
      appIntl,
      // intl: { messages },
    } = this.props;

    const items = [];
    if (quote.items) {
      _forEach(quote.items, item => {
        let grossPrice = item.item.pricing.price;
        let vatRate = item.item.pricing.vat_rate || item.item.pricing.vatRate;
        // let variantDescription = '';

        if (item.variant && item.variant.id) {
          grossPrice = item.variant.pricing.price;
          vatRate = item.variant.pricing.vat_rate || item.variant.pricing.vatRate;
          // variantDescription = getVariantDescription(item.variant, appIntl, messages);
        }

        const data = {
          id: item?.item?.id,
          name: item?.name,
          description: item?.description,
          quantity: 1,
          net_price: getNetFromGross(grossPrice, vatRate),
          gross_price: grossPrice,
          vat_rate: vatRate,
          item: item.item,
          variant: item.variant,
        };

        items.push(data);
      });
    }

    return items;
  };

  // user selected a variant option
  changePositionVariant = selectedVariant => {
    const {
      appIntl,
      intl: { messages },
    } = this.props;
    const { entity, editedRow, itemVariantValidation } = this.state;

    const tree = ['positions', editedRow];
    const editPosition = entity.getPositions()[editedRow];

    if (selectedVariant) {
      const variantDescription = getVariantDescription(selectedVariant, appIntl, messages);
      const newName = (
        <>
          <div class="bold">{editPosition?.item?.name}</div> {variantDescription}
        </>
      );
      const grossPrice = selectedVariant.pricing.price;
      const netPrice = grossPrice / (1 + selectedVariant.pricing.vat_rate / 100);
      this.updateEntityMultiple(
        ['variant', 'name', 'netPrice'],
        [selectedVariant, newName, netPrice],
        [tree, tree, tree]
      );
      this.updateVatRate(selectedVariant.pricing.vat_rate);

      this.setState({
        itemVariantValidation: {
          ...itemVariantValidation,
          [editPosition?.item?.id]: true,
        },
      });
    } else {
      this.setState({
        itemVariantValidation: {
          ...itemVariantValidation,
          [editPosition?.item?.id]: false,
        },
      });
    }
  };

  isItemVariantValid = itemId => {
    const { itemVariantValidation } = this.state;

    if (typeof itemVariantValidation[itemId] === 'boolean') {
      return itemVariantValidation[itemId];
    }

    return true;
  };

  addItem = item => {
    const { entity } = this.state;
    const { appIntl } = this.props;
    const grossPrice = item.pricing.price;
    const vatRate = item.pricing.vat_rate || item.pricing.vatRate;
    const data = {
      name: getNameInCurrentLanguage(item?.name, appIntl),
      description: getDescriptionInCurrentLanguage(item?.description, appIntl),
      quantity: 1,
      net_price: getNetFromGross(grossPrice, vatRate),
      gross_price: grossPrice,
      vat_rate: vatRate,
      item,
    };

    const positions = entity.getPositions().slice();
    positions.push(data);

    this.updateEntity('positions', positions, [], () => {
      this.setState({ showAddItem: false, showAddManual: false, editedRow: positions.length - 1 });
    });
  };

  /**
   * Create an Item from form-supplied manually entered data
   * @param {Object} params
   */
  createItem = formData => {
    const { name, description, price, vat, quantity } = formData;
    const item = {
      name,
      description,
      quantity,
      pricing: {
        price,
        vat_rate: vat,
      },
    };

    return item;
  };

  addManualItem = formData => {
    const { entity } = this.state;
    const { appIntl } = this.props;
    const item = this.createItem(formData);

    const data = {
      name: item?.name,
      description: item?.description,
      quantity: item.quantity,
      net_price: item.pricing.price,
      gross_price: getGrossFromNet(item.pricing.price, item.pricing.vat_rate),
      vat_rate: item.pricing.vat_rate,
      item,
    };

    const positions = entity.getPositions().slice();
    positions.push(data);

    this.updateEntity('positions', positions, [], () => {
      this.setState({ showAddItem: false, showAddManual: false });
    });
  };

  handleDeleteClick = (e, index) => {
    const { entity } = this.state;

    const positions = entity.getPositions().slice();
    positions.splice(index, 1);

    this.updateEntity('positions', positions);
  };

  editItem = (formData) => {
    const { entity, editingRow } = this.state;
    const positions = entity.getPositions().slice();
    const item = this.createItem(formData);

    const data = {
      name: item.name,
      description: item.description,
      quantity: item.quantity,
      net_price: item.pricing.price,
      gross_price: getGrossFromNet(item.pricing.price, item.pricing.vat_rate),
      vat_rate: item.pricing.vat_rate,
      item,
    };
    positions[editingRow] = data;

    this.updateEntity('positions', positions, [], () => {
      this.setState({ dataToEdit: undefined, editingRow: undefined });
    });
  }


  handleEditNew = rowNumber => {
    const { entity } = this.state;
    const positions = entity.getPositions();
    const position = positions?.[rowNumber];
    this.setState({ dataToEdit: position, editingRow: rowNumber });
  };



  showPositionPrice = position => {
    const { webApp } = this.props;
    return <FormattedNumber value={position.getNetPrice()} style="currency" currency={webApp.currency} />;
  };

  showPositionVatRate = position => {
    if (position.getVatRate() >= 0 && position.getVatRate() !== null) {
      return <FormattedNumber value={position.getVatRate() / 100} style="percent" />;
    }

    return 'n/a';
  };

  showEditDeliveryDate = e => {
    e.preventDefault();
    this.setState({ showEditDeliveryDate: true });
  };

  showEditComment = e => {
    this.setState({ showEditComment: true, showEditTermsOfPayment: false });
  };

  showEditTermsOfPayment = e => {
    this.setState({ showEditTermsOfPayment: true, showEditComment: false });
  };


  showEditDeliveryAddress = e => {
    e.preventDefault();
    this.setState({ showEditDeliveryAddress: true });
  };

  showAddItem = e => {
    e.preventDefault();
    this.setState({ showAddItem: true });
  };

  closeAddItem = () => {
    this.setState({ showAddItem: false });
  };

  handleEditClick = (e, editedRow) => {
    this.setState({ editedRow });
  };

  handleEditCloseClick = () => {
    this.setState({ editedRow: null });
  };

  handleEditCancelClick = () => {
    this.setState({ editedRow: null });
  };

  updatePosition = (name, value) => {
    const { editedRow } = this.state;
    this.updateEntity(name, value, ['positions', editedRow]);
  };

  /**
   * When net price is updated,
   * must also update the gross price from net and VAT.
   * @param {number} netPrice updated net price
   */
  onNetPriceUpdate = netPrice => {
    const { entity, editedRow } = this.state;
    const position = entity.getPositions()[editedRow];

    this.updatePosition('netPrice', netPrice);
    this.updateVatRate(position.getVatRate());
  };

  updateOwner = (_fieldName, owner) => {
    this.setState({ owner });
  };

  vatRateOptions = () => {
    const { user } = this.props;

    const options = [
      <MenuItem key="n/a" eventKey={null}>
        n/a
      </MenuItem>,
    ];

    const rates = user?.financial?.vat_rates;
    if (rates) {
      for (let i = 0; i < rates.length; i++) {
        options.push(
          <MenuItem key={rates[i]} eventKey={rates[i]}>
            <FormattedNumber value={rates[i] / 100} style="percent" />
          </MenuItem>
        );
      }
    }

    return options;
  };

  updateVatRate = vatRate => {
    const { entity, editedRow } = this.state;
    const tree = ['positions', editedRow];
    this.updateEntityMultiple(
      ['vatRate', 'grossPrice'],
      [vatRate, getGrossFromNet(entity.getPositions()[editedRow].getNetPrice(), vatRate)],
      [tree, tree]
    );
  };

  manualQuoteStatusOptions = () => {
    const options = [
      <MenuItem key="n/a" eventKey={null}>
        &mdash;
      </MenuItem>,
      ...Object.entries(this.choices).map(([choice, text]) => (
        <MenuItem key={choice} eventKey={choice}>
          {text}
        </MenuItem>
      )),
    ];

    return options;
  };

  updateDocTemplate = (fieldName, docTemplate) => {
    this.updateEntityMultiple(
      [fieldName, 'numberPrefix'],
      [docTemplate, (docTemplate && docTemplate.number_prefix) || '']
    );
  };

  updateDeliveryDate = (name, value) => {
    this.updateEntity(name, value, [], this.deliveryDateUpdated);
  };

  deliveryDateUpdated = () => {
    this.deliveryDateUpdatedTimeout = setTimeout(() => {
      this.setState({ showEditDeliveryDate: false });
    }, 3000);
  };

  resetDeliveryDate = e => {
    e.stopPropagation();
    this.updateEntity('deliveryDate', null);
  };

  onAddressUpdate = (addressType, contactData, addressData) => {
    // type: EmbeddedAddressInformationWithEmbeddedClientData
    const shippingAddress = {
      contact: contactData,
      address: addressData,
      // TODO: fill the "addressData" field with type FinanceBundle\Document\EmbeddedClientData
    };
    this.updateEntity('shippingAddress', shippingAddress);
  };

  onShow = () => {
    const { quote, meta } = this.props;

    // property names to copy from Quote
    const propNames = [
      'authorized_by',
      'authorized_by_name',
      'authorized_on',
      'comment',
      'currency',
      'currency_symbol',
      'delivery_date',
      'deposit',
      'deposit_amount',
      'deposit_type',
      'did_target_open',
      'doc_template',
      'invoice',
      'is_accepted',
      'is_authorized',
      'is_auto_generated',
      'is_rejected',
      'language',
      'lead',
      'manual_quote_status',
      'number_prefix',
      'owner_data',
      'owner_logo',
      'positions',
      'quote',
      'shipping_address',
      'sum_gross',
      'sum_net',
      'target',
      'target_data',
      'target_organisation',
      'target_organisation_data',
      'vat_name',
      'vat_sum_rates',
      'terms_of_payment',
      'invoice_for_services'
    ];
    const data = Object.fromEntries(propNames.map(propName => [propName, quote[propName]]));
    this.entity.setData(data);

    if (meta[FINANCE_QUOTE] !== undefined && !meta[FINANCE_QUOTE].pending && this.entity?.data !== null) {
      this.entity.setMeta(meta, FINANCE_QUOTE);

      this.setState({
        entityLoaded: true,
        entity: this.entity,
      });
    }

    this.setState({ sendByEmail: false, contactReferenceId:  quote?.lead?.target?.profile?.contact_reference_id ?? null }); // fix for the second time this form is used
  };

  onExit = () => {
    this.entity = new Entity();
    this.setState({ entity: null, entityLoaded: false, entityChanged: false, editedRow: null, showAddItem: false });
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      webApp,
      show,
      close,
      formStatus,
      user,
      variants,
    } = this.props;

    const {
      entity,
      entityLoaded,
      editedRow,
      owner,
      showEditDeliveryDate,
      showEditComment,
      showAddItem,
      showAddManual,
      sendByEmail,
      dataToEdit,
      editingRow,
      showEditTermsOfPayment,
      contactReferenceId,
    } = this.state;

    const disabled = formStatus.pending;
    const timezone = user && user.profile ? user.profile.timezone : 'UTC';
    const deposit = this.getDeposit();
    const manualQuoteStatus = this.choices[entity?.getManualQuoteStatus?.()] ?? <>&mdash;</>;

    return (
      <Modal show={show} onHide={close} bsSize="lg" className="full-width" onExit={this.onExit} onShow={this.onShow}>
        <Modal.Header closeButton>
          <Modal.Title>{messages.copy_quote}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Data dataName="quote" />
          <FormErrors formStatus={formStatus} />

          {entityLoaded ? (
            <form type="post" onSubmit={this.onSubmit}>
              <Row className="m-b-20">
                <Col xs={12} sm={6}>
                  <div className="form-group-attached">
                    <FormHoldingCompany
                      onChange={this.updateOwner}
                      selectedClient={owner && owner.username}
                      disabled={disabled}
                    />
                    {/* <FormAutocomplete
                      label={messages.document_template}
                      name="docTemplate"
                      value={docTemplateOptionFromEntity(entity?.getDocTemplate())}
                      onChange={this.updateDocTemplate}
                      returnValueObject
                      autocompleteType="docTemplate"
                      disabled={disabled}
                      urlFilters={{ filters: { language: appIntl.locale, systemType: 'quote' } }}
                      clearable
                    /> */}
                    <FormAutocomplete
                      label={messages.target_organisation}
                      name="targetOrganisation"
                      value={clientOptionFromEntity(entity.getTargetOrganisation?.())}
                      meta={entity.getTargetOrganisationMetaInformation?.()}
                      validation={entity.getTargetOrganisationValidationResult?.()}
                      onChange={this.updateEntity}
                      returnValueObject
                      autocompleteType="client"
                      disabled={disabled}
                      clearable
                    />
                  </div>

                  <p className="m-t-15 form-group-title" />
                  <div className="form-group-attached">
                    {showEditDeliveryDate ? (
                      <DatePicker
                        value={entity?.getDeliveryDate?.()}
                        locale={appIntl.locale}
                        displayTz={timezone}
                        onChange={this.updateDeliveryDate}
                        label={messages.delivery_date}
                        disabled={disabled}
                        name="deliveryDate"
                      />
                    ) : (
                      <div
                        className="form-group form-group-default p-t-10 p-b-10 cursor"
                        onClick={this.showEditDeliveryDate}
                      >
                        <label>
                          {messages.delivery_date} <i className="m-l-10 fa fa-pencil-alt" />
                        </label>
                        <Clearfix className="text-master">
                          {entity?.getDeliveryDate?.() ? (
                            <IntlDate date={entity.getDeliveryDate()} />
                          ) : (
                            messages.edit_delivery_date
                          )}
                          {!!entity?.getDeliveryDate?.() && (
                            <Button class="text-danger pull-right" bsSize="xsmall" onClick={this.resetDeliveryDate}>
                              <i class="fa fa-times" />
                            </Button>
                          )}
                        </Clearfix>
                      </div>
                    )}

                    {showEditComment || (entity.getComment && entity.getComment()) ? (
                      <FormRichEditor
                        name="comment"
                        label={messages.comment}
                        value={entity.getComment()}
                        meta={entity.getCommentMetaInformation()}
                        validation={entity.getCommentValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    ) : (
                      <div
                        className="form-group form-group-default p-t-10 p-b-10 cursor"
                        onClick={this.showEditComment}
                      >
                        <label>
                          {messages.comment} <i class="m-l-10 fa fa-pencil-alt" />
                        </label>
                        <span className="text-master">{messages.edit_comment}</span>
                      </div>
                    )}
                  </div>
                </Col>
                <Col xs={12} sm={6}>
                  <div className="form-group-attached">
                    <div className="form-group form-group-default" style={{ minHeight: '5 em' }}>
                      <label>{messages.email_on_save}</label>
                      <FormSwitchery
                        label={messages.email_to_the_customer_on_save}
                        value
                        onChange={(_, sendByEmail) => this.setState({ sendByEmail })}
                      />
                    </div>
                  </div>
                  <div className="form-group-attached">
                    <div className="form-group form-group-default" style={{ minHeight: '5 em', overflow: 'unset' }}>
                      <label>{messages.manual_quote_status}</label>
                      <DropdownButton
                        className="no-border bg-transparent"
                        id="manual-quote-status-dropdown"
                        title={manualQuoteStatus}
                        onSelect={value => this.updateEntity('manualQuoteStatus', value)}
                      >
                        {this.manualQuoteStatusOptions()}
                      </DropdownButton>
                    </div>
                  </div>
                  <div>
                    {showEditTermsOfPayment || (entity.getTermsOfPayment && entity.getTermsOfPayment()) ? (
                      <FormRichEditor
                        name="termsOfPayment"
                        label={messages.terms_of_payment}
                        value={entity.getTermsOfPayment()}
                        meta={entity.getTermsOfPaymentMetaInformation()}
                        validation={entity.getTermsOfPaymentValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    ) : (
                      <div
                        className="form-group form-group-default p-t-10 p-b-10 cursor"
                        onClick={() => {
                          this.showEditTermsOfPayment();
                        }}
                      >
                        <label>
                          {messages.terms_of_payment} <i className="m-l-10 fa fa-pencil-alt"/>
                        </label>
                        <span className="text-master">{messages.terms_of_payment_edit}</span>
                      </div>
                    )}
                  </div>
                  <FormSwitchery
                    name="invoiceForServices"
                    checked={!!entity?.getInvoiceForServices?.()}
                    value
                    label={messages.invoice_for_service}
                    onChange={this.updateEntity}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <div className="form-group-attached">
                    <div className="form-group form-group-default" style={{ minHeight: '5 em' }}>
                      <label>{messages.address_delivery}</label>
                      <QuoteAddress
                        username={entity.getTargetOrganisation?.()?.getUsername?.()}
                        onAddressUpdate={this.onAddressUpdate}
                        defaultAddresses={entity?.data?.shipping_address}
                        addressType="shippingAddress"
                        contactReferenceId={contactReferenceId}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              <h4>{messages.item}</h4>

              <Table hover={!disabled}>
                <thead>
                  <tr>
                    <th>{messages.salesDoc.name}</th>
                    <th>{messages.salesDoc.description}</th>
                    <th>{messages.salesDoc.unit_price}</th>
                    <th>{user.financial.vat_name} %</th>
                    <th>{messages.salesDoc.quantity}</th>
                    <th className="text-right">{messages.actions}</th>
                  </tr>
                </thead>
                <tbody>
                  {entity.getPositions?.().map((position, i) => {
                    const editMode = editedRow === i && !disabled;
                    const hasVariants = !!position.item.variants?.length;
                    const isVariantInvalid = hasVariants && !this.isItemVariantValid(position.item?.id);

                    return (
                      <React.Fragment key={position.getId()}>
                        {editMode && hasVariants && (
                          <List
                            noRender
                            listName="itemVariants"
                            url={'/api/items/' + position.item?.id + '/variants.json'}
                            list={variants}
                          />
                        )}

                        <tr
                          key={position.getId()}
                          className={editedRow !== null && editedRow !== i ? 'hint-text ' : ''}
                        >
                          <td className="v-align-middle">
                            {typeof position.name === 'object' ? getNameInCurrentLanguage(position.name, appIntl) : position.name}
                            {editMode && hasVariants ? (
                              variants.pending ? (
                                <Loader />
                              ) : (
                                <ItemVariantSelectors
                                  item={position.item}
                                  variants={variants.data.list}
                                  selectedVariant={position.variant ? position.variant : variants.data.list[0]}
                                  changeVariant={this.changePositionVariant}
                                />
                              )
                            ) : null}
                          </td>
                          <td className="v-align-middle">
                            {typeof position.description === 'object' ? getDescriptionInCurrentLanguage(position.description, appIntl) : ReactHtmlParser(position.description)}
                          </td>
                          <td className="v-align-middle">
                            {editMode ? (
                              <FormPriceNetGross
                                netValue={position.getNetPrice()}
                                vatRate={position.getVatRate() || 0}
                                onChange={this.onNetPriceUpdate}
                                currency={'&euro;'}
                              />
                            ) : (
                              this.showPositionPrice(position)
                            )}
                          </td>
                          <td className="v-align-middle">
                            {editMode ? (
                              <DropdownButton
                                className="no-border bg-transparent"
                                id="quote-vat-rate-dropdown"
                                title={this.showPositionVatRate(position)}
                                pullRight
                                onSelect={this.updateVatRate}
                              >
                                {this.vatRateOptions()}
                              </DropdownButton>
                            ) : (
                              this.showPositionVatRate(position)
                            )}
                          </td>
                          <td className="v-align-middle">
                            {editMode ? (
                              <FormInput
                                type="number"
                                name="quantity"
                                value={position.quantity}
                                onChange={this.updatePosition}
                              />
                            ) : (
                              position.quantity
                            )}
                          </td>
                          <td className="text-right v-align-middle">
                            {editMode && (
                              <React.Fragment>
                                <React.Fragment>
                                  <Button className="m-r-5" onClick={this.handleEditCancelClick}>
                                    <i className="fal fa-ban" />
                                  </Button>
                                  <Button onClick={this.handleEditCloseClick} disabled={isVariantInvalid}>
                                    <i className="fal fa-check" />
                                  </Button>
                                  {isVariantInvalid && (
                                    <div className="text-danger m-t-20">{messages.no_valid_variant}</div>
                                  )}
                                </React.Fragment>
                              </React.Fragment>
                            )}
                            {editedRow === null && (
                              <React.Fragment>
                                <Button
                                  onClick={() => {
                                    this.handleEditNew(i);
                                  }}
                                >
                                  <i className="fa fa-pencil-alt" /> {messages.edit}
                                </Button>{' '}
                                <Button
                                  onClick={e => {
                                    this.handleDeleteClick(e, i);
                                  }}
                                >
                                  <i className="far fa-trash-alt" />
                                </Button>
                              </React.Fragment>
                            )}
                          </td>
                        </tr>
                        {dataToEdit !== undefined && editingRow === i && (
                          <tr>
                            <td colSpan={6}>
                              <FormItemManual
                                disabled={formStatus.pending}
                                onSave={this.editItem}
                                onCancel={() => this.setState({ showAddManual: false, dataToEdit: undefined, editingRow: undefined })}
                                vatRateOptions={this.vatRateOptions()}
                                dataToEdit={dataToEdit}
                                index={this.state.editingRow}
                              />
                            </td>
                          </tr>
                        )}

                      </React.Fragment>
                    );
                  })}
                </tbody>
              </Table>

              {showAddItem || showAddManual ? (
                <div className="p-t-20 p-b-20 form-group-attached">
                  {showAddItem && (
                    <FormItemSearch
                      onSelect={(name, item) => this.addItem(item)}
                      disabled={formStatus.pending}
                      onCancel={this.closeAddItem}
                    />
                  )}
                  {showAddManual && (
                    <FormItemManual
                      disabled={formStatus.pending}
                      onSave={this.addManualItem}
                      onCancel={() => this.setState({ showAddManual: false })}
                      vatRateOptions={this.vatRateOptions()}
                    />
                  )}
                </div>
              ) : (
                <div className="p-t-20 p-b-20 text-center">
                  <Button onClick={this.showAddItem} className="btn-rounded" bsStyle="primary">
                    <i className="fa fa-plus" /> {messages.add_product}
                  </Button>
                  <Button
                    onClick={() => this.setState({ showAddManual: true, dataToEdit: undefined, editingRow: undefined })}
                    className="btn-rounded m-l-20"
                    bsStyle="primary"
                  >
                    <i className="fa fa-plus" /> {messages.add_manual_entry}
                  </Button>
                </div>
              )}

              <Row className="m-b-20 m-t-20">
                <Col xs={12} md={6} mdOffset={6}>
                  <hr />
                  <Row className="text-right">
                    <Col xs={4}>
                      <DropdownButton
                        className="no-border bg-transparent"
                        id="deposit-type-dropdown"
                        title={messages.deposit + ' (' + deposit.typeLabel + ')'}
                        pullRight
                        onSelect={depositType =>
                          this.updateEntityMultiple(['deposit', 'depositType'], [0, depositType])
                        }
                      >
                        <MenuItem key="percent" eventKey="percent">
                          %
                        </MenuItem>
                        <MenuItem key="fixed" eventKey="fixed">
                          {webApp.currencySymbol}
                        </MenuItem>
                      </DropdownButton>
                    </Col>
                    <Col xs={8}>
                      <DropdownButton
                        className="no-border bg-transparent"
                        id="deposit-value-dropdown"
                        title={deposit.valueLabel}
                        pullRight
                        onSelect={depositValue => this.updateEntity('deposit', depositValue)}
                      >
                        {this.depositValueOptions()}
                      </DropdownButton>
                    </Col>
                  </Row>
                  <hr />
                  <SalesDocumentSummary doc={entity} />
                </Col>
              </Row>

              <div className="text-right m-t-50">
                <Button bsStyle="primary" bsSize="lg" disabled={formStatus.pending || editedRow !== null} type="submit">
                  {formStatus.pending ? (
                    <i className="fa-fw fa fa-circle-notch fa-spin m-r-5" />
                  ) : sendByEmail ? (
                    <i className="fa-fw fal fa-paper-plane m-r-5" />
                  ) : (
                    <i className="fa-fw fal fa-save m-r-5" />
                  )}
                  {sendByEmail ? messages.save_and_email : messages.save}
                </Button>
              </div>
            </form>
          ) : (
            <Loader />
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    webApp: state.webApp,
    appIntl: state.intl,
    meta: state.entityMeta,
    formStatus: state.formStatus.quoteNew,
    user: state.login.user,
    projectConfig: state.data.projectConfig,
    variants: state.list.itemVariants,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: (clientId, args) => {
      formStatusDispatchHelper('quoteNew', `/api/clients/${clientId}/quotes.json`, args, 'post', dispatch);
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(LeadQuoteNewCopy)
  )
);
